/**
 * Marks a page or panel as one surface of the change ledger
 * (`lib/surface.ts`): its subtree carries `data-surface`, and while it is
 * mounted the API client names it on every write. `display: contents`, so the
 * wrapper never changes a layout.
 */
import { useEffect, type ReactNode } from "react";
import type { ClientSurface } from "@scandi/shared";
import { enterSurface } from "@/lib/surface";

export function Surface({ name, children }: { name: ClientSurface; children: ReactNode }) {
  useEffect(() => enterSurface(name), [name]);
  return (
    <div data-surface={name} className="contents">
      {children}
    </div>
  );
}
